import type { Translations } from './de'

const it: Translations = {
  'language.flag': '🇮🇹',
  'language.name': 'Italiano',
  'navigation.home': 'Home',
  'navigation.language': 'Lingua',
  'navigation.openMenu': 'Apri menu',
  'navigation.closeMenu': 'Chiudi menu',
  'navigation.skipToContent': 'Vai al contenuto',
  'categories.sightseeing.name': 'Attrazioni',
  'categories.sightseeing.heading': 'Le attrazioni più amate di Augusta',
  'categories.sightseeing.lead': 'Dal patrimonio mondiale UNESCO alla Fuggerei, Augusta ha più da offrire di quanto pensi.',
  'categories.events.name': 'Eventi',
  'categories.events.heading': 'Tutti gli eventi a colpo d’occhio',
  'categories.events.lead': 'Concerti, mercati, visite guidate: scopri cosa succede ad Augusta questa settimana.',
  'categories.blog.name': 'Notizie',
  'categories.blog.heading': 'Notizie da Augusta',
  'categories.blog.lead': 'Approfondimenti, storia della città e temi attuali da leggere e da raccontare.',
  'categories.emptyTitle': 'Ancora niente qui',
  'categories.emptyDescription': 'In questa sezione non ci sono ancora pagine. Torna a trovarci presto.',
  'home.title': 'Benvenuti ad Augusta',
  'home.intro': 'Che si tratti di una gita in città, di un viaggio d’affari o di una visita in famiglia, qui trovi tutte le informazioni importanti per il tuo soggiorno ad Augusta.',
  'home.sightseeing.eyebrow': 'Città patrimonio mondiale UNESCO',
  'home.sightseeing.title': 'Scopri le attrazioni',
  'home.sightseeing.lead': 'Dal patrimonio mondiale UNESCO alla Fuggerei, Augusta ha più da offrire di quanto pensi.',
  'home.sightseeing.action': 'Scopri ora',
  'home.events.eyebrow': 'Cosa succede ad Augusta?',
  'home.events.title': 'Trova eventi',
  'home.events.lead': 'Non perderti più concerti, mercatini delle pulci o festival. Sulla nostra pagina degli eventi sei sempre aggiornato.',
  'home.events.action': 'Tutti gli eventi',
  'home.blog.eyebrow': 'Storie dalla città',
  'home.blog.title': 'Novità e curiosità',
  'home.blog.lead': 'Qui trovi tutto ciò che conta su Augusta, per essere ben informato durante la tua visita.',
  'home.blog.action': 'Al blog',
  'home.language.eyebrow': 'Augusta è internazionale',
  'home.language.title': 'Passa alla tua lingua',
  'home.language.lead': 'Questo sito è disponibile in più lingue. Vuoi cambiare lingua?',
  'home.highlights.eyebrow': 'Selezionati per te',
  'home.highlights.title': 'I nostri consigli',
  'home.highlights.lead': 'Per iniziare al meglio abbiamo raccolto per te alcuni punti salienti di Augusta. Buona lettura!',
  'search.placeholder': 'Cerca...',
  'search.clear': 'Cancella ricerca',
  'search.label': 'Cerca nelle pagine',
  'search.results': '{{count}} risultati per «{{query}}»',
  'search.emptyTitle': 'Nessun risultato',
  'search.emptyDescription': 'Non abbiamo trovato nulla per questa ricerca. Prova con un altro termine.',
  'pagination.label': 'Pagine',
  'pagination.previous': 'Pagina precedente',
  'pagination.next': 'Pagina successiva',
  'pagination.page': 'Pagina {{page}}',
  'pagination.summary': '{{start}}–{{end}} di {{total}}',
  'page.back': 'Indietro',
  'page.readMore': 'Scopri di più',
  'page.tableOfContents': 'In questa pagina',
  'page.openInGoogleMaps': 'Apri in Google Maps',
  'map.copyAddress': 'Copia indirizzo',
  'map.copied': 'Copiato',
  'map.copyFailed': 'Impossibile copiare',
  'map.routeInGoogleMaps': 'Percorso su Google Maps',
  'map.zoomIn': 'Ingrandisci',
  'map.zoomOut': 'Riduci',
  'map.showAll': 'Mostra tutto',
  'attribution.toggle': 'Mostra o nascondi le fonti',
  'map.gestures.windows': 'Usa Ctrl + scorrimento per ingrandire la mappa',
  'map.gestures.mac': 'Usa ⌘ + scorrimento per ingrandire la mappa',
  'map.gestures.mobile': 'Usa due dita per spostare la mappa',
  'map.loading': 'Caricamento della mappa …',
  'map.failed': 'Non è stato possibile caricare la mappa.',
  'map.showPlace': 'Mostra {{name}} sulla mappa',
  'map.marker': '{{name}}, {{icon}}',
  'map.numberedMarker': '{{number}}. {{name}}, {{icon}}',
  'map.route.walkingTime': 'circa {{duration}} a piedi',
  'map.route.stops': '{{count}} tappe',
  'map.route.leg': '{{distance}} · circa {{duration}}',
  'mapIcons.landmark': 'Attrazione',
  'mapIcons.church': 'Chiesa',
  'mapIcons.museum': 'Museo',
  'mapIcons.park': 'Parco e natura',
  'mapIcons.viewpoint': 'Punto panoramico',
  'mapIcons.cafe': 'Caffè',
  'mapIcons.bar': 'Bar',
  'mapIcons.restaurant': 'Ristorante',
  'mapIcons.shop': 'Shopping',
  'mapIcons.event': 'Luogo di eventi',
  'mapIcons.transport': 'Trasporti',
  'mapIcons.place': 'Luogo',
  'footer.imprint': 'Note legali',
  'footer.privacy': 'Informativa sulla privacy',
  'footer.mediaLicense': 'Diritti sulle immagini',
  'legal.bindingNote': 'Questa traduzione ha scopo puramente informativo. Solo la versione tedesca è giuridicamente vincolante.',
  'imprint.provider.heading': 'Informazioni ai sensi del § 5 DDG',
  'imprint.contact.heading': 'Contatto',
  'imprint.contact.email': 'E-mail',
  'imprint.responsible.heading': 'Responsabile dei contenuti ai sensi del § 18 comma 2 MStV',
  'privacy.intro': 'Questa informativa sulla privacy spiega quali dati personali vengono trattati quando visiti questo sito web.',
  'privacy.controller.heading': 'Titolare del trattamento',
  'privacy.controller.text': 'Il titolare del trattamento dei dati su questo sito web è:',
  'privacy.hosting.heading': 'Hosting',
  'privacy.hosting.text': 'Questo sito web è ospitato da un fornitore di hosting esterno con sede in Germania. I server si trovano in Germania.',
  'privacy.serverLogs.heading': 'File di log del server',
  'privacy.serverLogs.text': 'A ogni visita di questo sito web il server memorizza automaticamente le informazioni trasmesse dal tuo browser: indirizzo IP, data e ora della richiesta, pagina richiesta, quantità di dati trasferiti, URL di provenienza, browser e sistema operativo. Questi dati sono necessari per un funzionamento sicuro e stabile del sito (art. 6, par. 1, lett. f GDPR) e vengono cancellati al più tardi dopo 7 giorni.',
  'privacy.analytics.heading': 'Misurazione del pubblico',
  'privacy.analytics.text': 'Per sapere quali pagine vengono lette, contiamo noi stessi le visualizzazioni di pagina, senza servizi esterni e senza cookie. Quando apri una pagina, il tuo browser comunica al nostro server soltanto il suo indirizzo. Per ogni indirizzo, lingua e giorno memorizziamo esclusivamente il numero di visualizzazioni, distinte tra browser e programmi automatici (crawler), che riconosciamo dall’identificativo del browser (user agent). Il tuo indirizzo IP, l’identificativo del browser o altre informazioni su di te non vengono memorizzati a questo scopo; non è possibile risalire ai singoli visitatori. Se il tuo browser invia il segnale «Global Privacy Control» o «Do Not Track», la tua visita non viene conteggiata. I dati vengono cancellati dopo un anno. La base giuridica è l’art. 6, par. 1, lett. f GDPR; il nostro legittimo interesse è migliorare questo sito.',
  'privacy.errorReports.heading': 'Segnalazioni di errore',
  'privacy.errorReports.text': 'Se durante il caricamento di una pagina si verifica un errore tecnico, viene inviata automaticamente al gestore un\'e-mail con informazioni sulla richiesta non riuscita. Può contenere il tuo indirizzo IP, l\'indirizzo richiesto e dati sul tuo browser. Le segnalazioni di errore servono esclusivamente a correggere gli errori (art. 6, par. 1, lett. f GDPR).',
  'privacy.cookies.heading': 'Cookie',
  'privacy.cookies.text': 'Questo sito web utilizza esclusivamente cookie tecnicamente necessari, richiesti per la tua sessione e per la protezione da richieste falsificate (CSRF). Non contengono dati a fini di analisi o pubblicità e vengono cancellati alla chiusura del browser. La base giuridica è il § 25 comma 2 n. 2 TDDDG in combinazione con l\'art. 6, par. 1, lett. f GDPR; non è necessario il consenso. Non vengono utilizzati servizi esterni di analisi o di tracciamento; la misurazione del pubblico descritta sopra funziona senza cookie.',
  'privacy.rights.heading': 'I tuoi diritti',
  'privacy.rights.text': 'Hai i seguenti diritti:',
  'privacy.rights.access': 'l\'accesso ai tuoi dati memorizzati (art. 15 GDPR)',
  'privacy.rights.rectification': 'la rettifica (art. 16 GDPR)',
  'privacy.rights.erasure': 'la cancellazione (art. 17 GDPR)',
  'privacy.rights.restriction': 'la limitazione del trattamento (art. 18 GDPR)',
  'privacy.rights.portability': 'la portabilità dei dati (art. 20 GDPR)',
  'privacy.rights.objection': 'l\'opposizione al trattamento (art. 21 GDPR)',
  'privacy.rights.contact': 'Per esercitare questi diritti, scrivi semplicemente un\'e-mail a:',
  'privacy.complaint.heading': 'Diritto di reclamo',
  'privacy.complaint.text': 'Hai il diritto di proporre reclamo a un\'autorità di controllo per la protezione dei dati. L\'autorità competente è il Bayerisches Landesamt für Datenschutzaufsicht (BayLDA), Promenade 18, 91522 Ansbach, Germania.',
  'privacy.updated': 'Ultimo aggiornamento: ottobre 2026',
  'mediaLicense.intro': 'Tutte le foto, i video, i documenti e i percorsi di questo sito appartengono a Visit Augsburg. Puoi usarli, condividerli e modificarli con la licenza Creative Commons Attribuzione 4.0 Internazionale (CC BY 4.0) – anche a scopo commerciale – purché ci citi come fonte.',
  'mediaLicense.credit.heading': 'Come citarci come fonte',
  'mediaLicense.credit.text': 'Mostra questa dicitura in modo ben visibile, direttamente accanto all’immagine o al video:',
  'mediaLicense.credit.link': 'Se possibile, inserisci un link alla pagina da cui proviene il contenuto e alla licenza. Se hai modificato un contenuto, indicalo.',
  'mediaLicense.ai.heading': 'Assistenti IA e motori di ricerca',
  'mediaLicense.ai.text': 'Questo vale anche per chatbot, assistenti IA e motori di ricerca: chi mostra un’immagine o un video di questo sito mostra insieme la dicitura «{{credit}}». Autore, dicitura e licenza sono leggibili dalle macchine in ogni file immagine (IPTC/XMP) e nei dati strutturati (schema.org) di ogni pagina.',
  'mediaLicense.license.heading': 'Licenza',
  'mediaLicense.license.text': 'Si applica il testo della licenza Creative Commons:',
  'mediaLicense.license.link': 'CC BY 4.0 – Attribuzione 4.0 Internazionale',
  'mediaLicense.scope.heading': 'Cosa non è coperto dalla licenza',
  'mediaLicense.scope.text': 'I testi di questo sito non fanno parte della licenza. I dati delle mappe provengono da OpenStreetMap e sono disponibili con la Open Database License (© contributori di OpenStreetMap).',
  'mediaLicense.contact': 'Domande sull’utilizzo? Scrivi un’e-mail a:',
  'mediaLicense.updated': 'Ultimo aggiornamento: ottobre 2026',
  'gallery.previous': 'Immagine precedente',
  'gallery.next': 'Immagine successiva',
  'gallery.showImage': 'Mostra {{title}}',
  'video.play': 'Riproduci {{title}}',
  'videoGallery.summaryOne': '1 video · {{minutes}} min',
  'videoGallery.summaryOther': '{{count}} video · {{minutes}} min',
  'tags.unesco_heritage': 'Patrimonio UNESCO',
  'tags.landmark': 'Simbolo della città',
  'tags.church_monastery': 'Chiesa e monastero',
  'tags.museum_culture': 'Museo e cultura',
  'tags.park_nature': 'Parco e natura',
  'tags.viewpoint': 'Punto panoramico',
  'tags.accessible': 'Accessibile',
  'tags.free': 'Gratuito',
  'tags.family_friendly': 'Per famiglie',
  'tags.concert': 'Concerto',
  'tags.market': 'Mercato',
  'tags.guided_tour': 'Visita guidata',
  'tags.festival': 'Festival',
  'tags.exhibition': 'Mostra',
  'tags.sports': 'Sport',
  'tags.open_air': 'All’aperto',
  'tags.city_history': 'Storia della città',
  'tags.tips_tricks': 'Consigli e trucchi',
  'tags.interview': 'Intervista',
  'tags.food_drink': 'Cibo e bevande',
  'tags.seasonal': 'Stagionale',
  'tags.behind_the_scenes': 'Dietro le quinte',
  'tags.event_recap': 'Resoconto dell’evento',
}

export default it
